<template>
    <v-dialog v-model="showDialog"
              class="date-dialog"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="date-time-form text-primary">
            <v-card-title>
                Выбор даты
            </v-card-title>

            <v-card-text class="py-0 px-4">
                <v-date-picker v-model="date"
                               show-adjacent-months
                               title="Выбрано"
                               header=""
                               :hide-header="!date"
                               class="text-primary"
                               color="primary"
                               :min="minDate"
                               :max="maxDate" />
            </v-card-text>

            <v-card-actions class="pt-0 pb-4 px-4">
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!date"
                       @click="reset">Сбросить</v-btn>
                <v-btn color="primary"
                       variant="elevated"
                       :disabled="!date"
                       @click="save">Применить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {

        },

        props: {
            modelValue: Object,
            minDate: Object,
            maxDate: Object
        },

        emits: ["update:modelValue", "hide"],

        data() {
            return {
                showDialog: true,
                date: this.modelValue
            };
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            reset() {
                this.date = null;
                this.$emit("update:modelValue", null);
            },

            save() {
                if (!this.date) {
                    return;
                }

                this.$emit("hide");
                this.$emit("update:modelValue", this.date);
            }
        }
    };
</script>

<style lang="scss">
    .date-dialog {
    }
</style>